import { baseApi } from './baseApi';
import type {
  MenuDigitalConfig,
  MenuEditor,
  UpdateMenuVisibilityRequest,
  UpdateMenuOrderRequest,
} from '../types/menuDigital';

// Configuración del menú digital (autenticada, solo gestión). El slug vive en
// la BD global y solo se escribe por su endpoint dedicado; plantilla, paleta y
// lema son settings del tenant y van por settingsApi.updateSetting.
export const menuDigitalApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMenuDigitalConfig: builder.query<MenuDigitalConfig, string>({
      query: (restaurantId) => `/restaurants/${restaurantId}/menu-digital/config`,
      providesTags: ['AppSettings'],
    }),
    updateMenuSlug: builder.mutation<void, { restaurantId: string; slug: string }>({
      query: ({ restaurantId, slug }) => ({
        url: `/restaurants/${restaurantId}/menu-digital/slug`,
        method: 'PUT',
        body: { slug },
      }),
      invalidatesTags: ['AppSettings'],
    }),

    // El lienzo del editor: el menú con lo oculto incluido.
    getMenuEditor: builder.query<MenuEditor, string>({
      query: (restaurantId) => `/restaurants/${restaurantId}/menu-digital/editor`,
      providesTags: ['MenuEditor'],
    }),
    updateMenuVisibility: builder.mutation<
      void,
      { restaurantId: string } & UpdateMenuVisibilityRequest
    >({
      query: ({ restaurantId, ...body }) => ({
        url: `/restaurants/${restaurantId}/menu-digital/visibility`,
        method: 'PUT',
        body,
      }),
      // NO invalida MenuEditor a propósito: quien manda esto es el propio
      // editor, que ya aplicó el cambio en su copia local. Refetchear pisaría
      // los clics dados durante el agrupamiento de 600ms y el ojo se vería
      // "rebotar". Sí invalida Product, porque la lista de Gestión del Menú
      // muestra la misma bandera en su columna de acciones rápidas.
      invalidatesTags: ['Product'],
    }),
    updateMenuOrder: builder.mutation<void, { restaurantId: string } & UpdateMenuOrderRequest>({
      query: ({ restaurantId, ...body }) => ({
        url: `/restaurants/${restaurantId}/menu-digital/order`,
        method: 'PUT',
        body,
      }),
      // Igual que visibility: el editor ya movió la fila en su copia local.
      invalidatesTags: ['Product', 'Category'],
    }),
  }),
});

export const {
  useGetMenuDigitalConfigQuery,
  useUpdateMenuSlugMutation,
  useGetMenuEditorQuery,
  useUpdateMenuVisibilityMutation,
  useUpdateMenuOrderMutation,
} = menuDigitalApi;
